import { useEffect, useState } from "react";
import { Minus, Plus, Wand2, Save, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/Widgets";

export const FREQ_TYPES = [
  ["instagram_reel", "Reel Instagram"],
  ["instagram_carousel", "Caroselli Instagram"],
  ["instagram_post", "Post Instagram"],
  ["facebook_post", "Post Facebook"],
];

const Stepper = ({ value, onChange, testid }) => (
  <div className="flex items-center border border-[#E8E8E4] bg-white">
    <button data-testid={`${testid}-minus`} onClick={() => onChange(Math.max(0, value - 1))} className="px-2 py-1.5 hover:bg-[#F7F7F5]"><Minus className="w-3 h-3" /></button>
    <span data-testid={`${testid}-value`} className="font-mono-num text-sm w-7 text-center">{value}</span>
    <button data-testid={`${testid}-plus`} onClick={() => onChange(Math.min(14, value + 1))} className="px-2 py-1.5 hover:bg-[#F7F7F5]"><Plus className="w-3 h-3" /></button>
  </div>
);

export const FrequencyPanel = ({ prefs, onSave, onFill, filling, weeks, setWeeks, replace, setReplace, newIdeas, setNewIdeas, fillChars }) => {
  const [user, setUser] = useState(prefs.user);
  useEffect(() => { setUser(prefs.user); }, [prefs.user]);
  const s = prefs.suggested;
  const dirty = FREQ_TYPES.some(([k]) => user[k] !== prefs.user[k]);
  const total = (o) => FREQ_TYPES.reduce((a, [k]) => a + (o[k] || 0), 0);
  return (
    <Panel testid="frequency-settings" title="Frequenza di pubblicazione" sub={prefs.has_strategy ? "Confronta il suggerimento dell'AI con la tua scelta" : "Genera una Strategia AI per ricevere la frequenza suggerita"} className="mb-4">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="label !text-[10px] text-left"><th className="py-2 font-semibold">Tipo</th><th className="font-semibold">Suggerito AI / sett.</th><th className="font-semibold">La tua frequenza / sett.</th></tr></thead>
          <tbody>
            {FREQ_TYPES.map(([k, l]) => (
              <tr key={k} className="border-t border-[#E8E8E4]">
                <td className="py-2.5">{l}</td>
                <td><span data-testid={`suggested-${k}`} className="font-mono-num text-[#2A4B3C]">{s[k]}</span></td>
                <td><div className="flex items-center gap-3"><Stepper testid={`freq-${k}`} value={user[k]} onChange={(v) => setUser({ ...user, [k]: v })} />
                  {user[k] !== s[k] && <span className="text-[11px] text-[#C05C3D]">{user[k] > s[k] ? "+" : ""}{user[k] - s[k]} vs AI</span>}</div></td>
              </tr>
            ))}
            <tr className="border-t border-[#E8E8E4] font-semibold"><td className="py-2.5">Totale</td><td className="font-mono-num">{total(s)}</td><td className="font-mono-num" data-testid="freq-total">{total(user)}</td></tr>
          </tbody>
        </table>
      </div>
      {s.stories_giorno != null && <p className="text-xs text-[#5C5C58] mt-3">Stories consigliate: <b>{s.stories_giorno} al giorno</b> (non pianificate nel calendario).</p>}
      {s.note && <p className="text-xs text-[#5C5C58] mt-1">{s.note}</p>}
      <div className="flex flex-wrap gap-2 mt-5 items-center">
        <Button data-testid="apply-suggested-btn" variant="outline" className="rounded-full" onClick={() => setUser(Object.fromEntries(FREQ_TYPES.map(([k]) => [k, s[k]])))}>Usa frequenza AI</Button>
        <Button data-testid="save-freq-btn" disabled={!dirty} variant="outline" className="rounded-full" onClick={() => onSave(user)}><Save className="w-4 h-4 mr-2" />Salva frequenza</Button>
        <span className="mx-2 h-6 w-px bg-[#E8E8E4]" />
        <select data-testid="fill-weeks-select" value={weeks} onChange={(e) => setWeeks(+e.target.value)} className="border border-[#E8E8E4] text-sm px-2 py-2 bg-white">
          {[1, 2, 4, 8].map((w) => <option key={w} value={w}>{w} {w === 1 ? "settimana" : "settimane"}</option>)}
        </select>
        <label className="text-xs flex items-center gap-1.5"><input data-testid="fill-replace-checkbox" type="checkbox" checked={replace} onChange={(e) => setReplace(e.target.checked)} />Sostituisci i suggerimenti AI non pubblicati</label>
        <label className="text-xs flex items-center gap-1.5"><input data-testid="fill-new-ideas-checkbox" type="checkbox" checked={newIdeas} onChange={(e) => setNewIdeas(e.target.checked)} />Crea idee nuove con l'AI se finiscono</label>
        <Button data-testid="fill-calendar-btn" disabled={filling} className="rounded-full bg-[#2A4B3C] hover:bg-[#36604C]" onClick={() => onFill(user, weeks, replace, dirty)}>{filling ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Wand2 className="w-4 h-4 mr-2" />}{fillChars != null ? `Creo idee nuove... ${fillChars} caratteri` : "Riempi calendario"}</Button>
      </div>
    </Panel>
  );
};
